import { createFileRoute } from "@tanstack/react-router"

import { AuswertungPage } from "@/components/admin/auswertung/auswertung-page"

export const Route = createFileRoute("/_app/admin/auswertung")({
  component: AuswertungPage,
})
